module.exports = new __parcel__URL__("BrickABrack.af7ad9a5.jpeg").toString();